import axios from '../axiosInstances/axiosInstance';

export const deleteAccount = () => {
  return axios.delete(`/users`);
};
